import { useEffect } from "react"
import { Link } from "react-router-dom"
import useUserStore from "stores/user"
import { useAuthenticatedUser } from "auth-provider"
import { useFlags } from "launchdarkly-react-client-sdk"
import { isProd } from "utils/networking"
import logoDark from "assets/images/logo-dark-optmized.png"
import ApproveModal from "components/ApproveModal"
import { UserMenu } from "./user-menu"
import { AppMenu } from "../main-menu"
import { useMenuItems } from "../main-menu/utils"
import { Button } from "components/ui/button"
import { CircleHelpIcon } from "lucide-react"
import { cn } from "lib/utils"
import { LanguageSwitcher } from "components/ui/language-switcher"

const Header = () => {
  const { user } = useAuthenticatedUser()
  const { customOutageBanner, ...flags } = useFlags()
  const { isCustomer, isDriver, isCommonCarrier, isCC } = useUserStore((s) => ({
    isCustomer: s.isCustomer,
    isDriver: s.isDriver,
    isCommonCarrier: s.isCommonCarrier,
    isCC: s.isCC,
  }))

  useEffect(() => {
    console.log("Launch Darkly Flags:", { ...flags })
  }, [flags])

  return (
    <header
      className={cn(
        "w-full px-2 flex items-center gap-2 h-[var(--header-height)] border-b border-border",
        !isProd ? "bg-sky-50" : "bg-white"
      )}
      style={{
        top: !customOutageBanner || customOutageBanner === "disabled" ? 0 : 25,
      }}
    >
      <AppMenu menuItems={useMenuItems(flags)} />
      <div className="flex items-center justify-start gap-3">
        <Link to="/">
          <img src={logoDark} alt="DashFuel" className="h-8 w-auto" />
        </Link>
        {!isProd && (
          <span className="rounded-md bg-sky-600 text-white px-1.5 py-0.5 text-xs font-bold">
            Dev
          </span>
        )}
      </div>
      <div className="flex-1" />
      <div className="flex items-center justify-end gap-1">
        {isCustomer || isDriver || isCommonCarrier || isCC ? null : (
          <ApproveModal />
        )}
        <Button
          variant="ghost"
          size="icon"
          className="ml-2"
          onClick={() =>
            (window.location.href = "mailto:support@getdashfuel.com")
          }
        >
          <CircleHelpIcon className="w-4 h-4" />
        </Button>
        <LanguageSwitcher />
        <UserMenu username={user?.full_name ?? ""} />
      </div>
    </header>
  )
}

export { Header }
